import type { ProfileConfig } from "@worker/config-schema";
import { el } from "../lib/dom";
import { renderProfileParts } from "./parts";

/**
 * Classic top-left layout (guns.lol parity). Avatar + name header at the top,
 * description below name, widgets/socials/links stacked, meta row with view
 * count + location + contact, audio player at the bottom.
 */
export function renderClassicTopLeft(
  config: ProfileConfig,
  options: { gateOpened: Promise<void> } = { gateOpened: Promise.resolve() },
): HTMLElement {
  const p = renderProfileParts(config, options);
  p.card.classList.add("card--classic");

  const header = el("header", { class: "card__header" }, [
    p.avatar,
    el("div", { class: "card__identity" }, [
      el("div", { class: "card__name-row" }, [p.username, p.badges]),
      p.description,
    ]),
  ]);

  const metaRow = el("div", { class: "card__meta card__meta--centered" });
  const vc = p.meta.getInline("views");         if (vc) metaRow.append(vc);
  const loc = p.meta.getInline("location");     if (loc) metaRow.append(loc);
  const clk = p.meta.getInline("clock");        if (clk) metaRow.append(clk);
  const ct = p.meta.getInline("contact");       if (ct) metaRow.append(ct);

  p.card.append(header);
  if (p.socials) p.card.append(wrapSlot("socials", p.socials));
  if (p.widgets) p.card.append(wrapSlot("widgets", p.widgets));
  if (p.links) p.card.append(wrapSlot("links", p.links));
  if (metaRow.childElementCount > 0) p.card.append(metaRow);
  if (p.audio) p.card.append(wrapSlot("audio", p.audio));
  // Float any top-left / top-right / bottom-left / bottom-right elements
  // into their corner zones on top of the card. Must come last so they're
  // positioned after the card has its normal content + padding baseline.
  p.meta.applyCornerZones();

  return p.card;
}

function wrapSlot(name: string, child: HTMLElement): HTMLElement {
  return el("div", { class: `card__slot card__slot--${name}`, "data-slot": name }, [child]);
}
